import { render, staticRenderFns } from "./NaoEncontrei.vue?vue&type=template&id=1c9234ee"
import script from "./NaoEncontrei.vue?vue&type=script&lang=js"
export * from "./NaoEncontrei.vue?vue&type=script&lang=js"
import style0 from "./NaoEncontrei.vue?vue&type=style&index=0&id=1c9234ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
